// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';


// utilities
import cx from 'classnames';

// components
import Modal from '../../components/r_Modal';
import ModalX from '../../svgs/ModalX';

// material
import FlatButton from '../../components/c_FlatButton';
import RaisedButton from '../../components/c_RaisedButton';

const flatButtonStyle = {
  width: '296px',
  height: '41px',
  marginRight: '25px'
};

const flatButtonLabelStyle = {
  fontSize: '12px',
  transform: 'translateY(-.5px)',
  top: 0
};


export default function InfoModal(props) {

  return (
    <Modal>
      <div className='transition-block-form'>
        <div>
          {props.title && <h1>{props.title}</h1>}
          <div className='prompt-text'>
          {props.text}{props.children}
          </div>
          <RaisedButton
            label={props.buttonLabel || 'Ok'}
            onClick={props.transitionFunc}
          />
        </div>
        <ModalX onClick={props.cancelFunc}/>
      </div>
      <div className='rectangle-behind-modal-form absolute-center'/>
    </Modal>
  );
}

InfoModal.propTypes = {
  transitionFunc: PropTypes.func,
  cancelFunc: PropTypes.func,
  text: PropTypes.string,
  buttonLabel: PropTypes.string,
  children: PropTypes.object,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./shared/common/components/f_InfoModal/index.js